module.exports = __webpack_public_path__ + "img/dot-info.076d939e.svg";